(function() {
  const STORAGE_KEY = 'electrodaves_wishlist_v1';

  window.Wishlist = {
    get() {
      try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        return [];
      }
    },

    save(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.updateBadge();
        this.renderDrawer();
        this.renderPage();
        this.syncHeartIcons();
        window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
      } catch (e) {
        console.error('Failed to save wishlist', e);
      }
    },

    has(id) {
      if (!id) return false;
      const items = this.get();
      return items.some(item => String(item.id) === String(id));
    },

    add(productData) {
      if (!productData || !productData.id) return;
      let items = this.get();
      if (!this.has(productData.id)) {
        const dateStr = new Date().toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        });
        items.unshift({
          id: String(productData.id),
          handle: productData.handle || '',
          title: productData.title || '',
          price: productData.price || '',
          compareAtPrice: productData.compareAtPrice || '',
          image: productData.image || '',
          url: productData.url || '#',
          variantId: productData.variantId || '',
          variants: productData.variants || [],
          dateAdded: `Added on ${dateStr}`
        });
        this.save(items);
      }
    },

    remove(id) {
      if (!id) return;
      let items = this.get();
      items = items.filter(item => String(item.id) !== String(id));
      this.save(items);
    },

    removeMultiple(ids) {
      if (!Array.isArray(ids) || ids.length === 0) return;
      let items = this.get();
      const stringIds = ids.map(id => String(id));
      items = items.filter(item => !stringIds.includes(String(item.id)));
      this.save(items);
    },

    toggle(productData) {
      if (this.has(productData.id)) {
        this.remove(productData.id);
        return false;
      } else {
        this.add(productData);
        return true;
      }
    },

    clear() {
      this.save([]);
    },

    updateBadge() {
      const items = this.get();
      const count = items.length;
      document.querySelectorAll('#wishlist-icon-bubble, .wishlist-count-bubble, .js-wishlist-drawer-count').forEach(bubble => {
        const countSpan = bubble.querySelector('span[aria-hidden="true"]');
        if (countSpan) countSpan.textContent = count;
        else bubble.textContent = count;
        if (bubble.classList.contains('wishlist-count-bubble')) {
          bubble.style.display = count > 0 ? 'flex' : 'none';
        }
      });
    },

    syncHeartIcons() {
      const items = this.get();
      const itemIds = items.map(item => String(item.id));
      document.querySelectorAll('.showcase-card__wishlist[data-product-id]').forEach(btn => {
        const id = String(btn.dataset.productId);
        if (itemIds.includes(id)) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    },

    openDrawer() {
      const drawer = document.getElementById('WishlistDrawer');
      const backdrop = document.getElementById('WishlistDrawerBackdrop');
      this.renderDrawer();
      if (drawer) {
        drawer.style.display = 'flex';
        setTimeout(() => drawer.classList.add('is-active'), 10);
      }
      if (backdrop) {
        backdrop.style.display = 'block';
        setTimeout(() => backdrop.classList.add('is-active'), 10);
      }
    },

    closeDrawer() {
      const drawer = document.getElementById('WishlistDrawer');
      const backdrop = document.getElementById('WishlistDrawerBackdrop');
      if (drawer) {
        drawer.classList.remove('is-active');
        setTimeout(() => drawer.style.display = 'none', 300);
      }
      if (backdrop) {
        backdrop.classList.remove('is-active');
        setTimeout(() => backdrop.style.display = 'none', 300);
      }
    },

    renderDrawer() {
      const grid = document.querySelector('.js-wishlist-drawer-grid');
      const emptyState = document.querySelector('.js-wishlist-drawer-empty');
      if (!grid) return;

      const items = this.get();
      if (items.length === 0) {
        grid.style.display = 'none';
        if (emptyState) emptyState.style.display = 'flex';
        return;
      }

      if (emptyState) emptyState.style.display = 'none';
      grid.style.display = 'flex';
      grid.innerHTML = items.map(item => `
        <div class="wishlist-drawer-item" data-id="${item.id}">
          <img src="${item.image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'}" alt="${item.title}" class="wishlist-drawer-item__img">
          <div class="wishlist-drawer-item__info">
            <a href="${item.url}" class="wishlist-drawer-item__title">${item.title}</a>
            <span class="wishlist-drawer-item__price">${item.price}</span>
            <div class="wishlist-drawer-item__actions">
              <button type="button" class="wishlist-drawer-item__remove-btn js-drawer-remove" data-id="${item.id}">Remove</button>
            </div>
          </div>
        </div>
      `).join('');

      grid.querySelectorAll('.js-drawer-remove').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const id = btn.dataset.id;
          window.Wishlist.remove(id);
        });
      });
    },

    renderPage() {
      const section = document.querySelector('.wishlist-section');
      if (!section) return;

      const grid = section.querySelector('.js-wishlist-grid');
      const emptyState = section.querySelector('.js-wishlist-empty');
      const toolbar = section.querySelector('.js-wishlist-toolbar');
      const selectAllCheckbox = section.querySelector('.js-wishlist-select-all');
      const bulkActions = section.querySelector('.js-wishlist-bulk-actions');

      const items = this.get();

      if (items.length === 0) {
        if (grid) grid.style.display = 'none';
        if (toolbar) toolbar.style.display = 'none';
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      if (emptyState) emptyState.style.display = 'none';
      if (toolbar) toolbar.style.display = 'flex';
      if (grid) grid.style.display = 'grid';

      const defaultBtnText = section.dataset.moveBtnText || 'Move to cart';

      grid.innerHTML = items.map(item => {
        let variantMarkup = '';
        if (Array.isArray(item.variants) && item.variants.length > 1) {
          variantMarkup = `
            <select class="wishlist-card__variant-select js-variant-select" data-id="${item.id}" aria-label="Select variant">
              ${item.variants.map(v => `<option value="${v.id}" ${String(v.id) === String(item.variantId) ? 'selected' : ''} data-price="${v.price || ''}">${v.title || v.name || 'Default'}</option>`).join('')}
            </select>
          `;
        } else if (item.variantTitle && item.variantTitle !== 'Default Title') {
          variantMarkup = `<p class="wishlist-card__variant-text">${item.variantTitle}</p>`;
        }

        return `
          <div class="wishlist-card" data-id="${item.id}" data-variant-id="${item.variantId}">
            <div class="wishlist-card__media">
              <input type="checkbox" class="wishlist__checkbox wishlist-card__select-checkbox js-item-checkbox" data-id="${item.id}" aria-label="Select ${item.title}">
              <button type="button" class="wishlist-card__remove-btn js-wishlist-remove-item" data-id="${item.id}" aria-label="Remove ${item.title} from wishlist" title="Remove">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
              </button>
              <a href="${item.url}" class="wishlist-card__image-link">
                <img src="${item.image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'}" alt="${item.title}" class="wishlist-card__image" loading="lazy">
              </a>
            </div>
            <div class="wishlist-card__content">
              <h3 class="wishlist-card__title">
                <a href="${item.url}">${item.title}</a>
              </h3>
              <div class="wishlist-card__prices">
                ${item.compareAtPrice ? `<s class="wishlist-card__compare-price">${item.compareAtPrice}</s>` : ''}
                <span class="wishlist-card__price js-card-price">${item.price}</span>
              </div>
              ${variantMarkup}
              <button type="button" class="wishlist-card__atc-btn js-wishlist-move-to-cart" data-id="${item.id}" data-variant-id="${item.variantId}">
                ${defaultBtnText}
              </button>
              <p class="wishlist-card__date">${item.dateAdded || ''}</p>
            </div>
          </div>
        `;
      }).join('');

      function updateBulkVisibility() {
        const checkedBoxes = grid.querySelectorAll('.js-item-checkbox:checked');
        const allBoxes = grid.querySelectorAll('.js-item-checkbox');

        if (bulkActions) {
          bulkActions.style.display = checkedBoxes.length > 0 ? 'inline-flex' : 'none';
        }
        if (selectAllCheckbox) {
          selectAllCheckbox.checked = allBoxes.length > 0 && checkedBoxes.length === allBoxes.length;
        }
      }

      // Initial visibility update
      updateBulkVisibility();

      // Bind Individual Remove
      grid.querySelectorAll('.js-wishlist-remove-item').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          window.Wishlist.remove(btn.dataset.id);
        });
      });

      // Bind Variant Selection Change
      grid.querySelectorAll('.js-variant-select').forEach(select => {
        select.addEventListener('change', (e) => {
          const card = select.closest('.wishlist-card');
          const selectedOpt = select.options[select.selectedIndex];
          const newVariantId = select.value;
          const newPrice = selectedOpt.dataset.price;

          if (card) {
            card.dataset.variantId = newVariantId;
            const atcBtn = card.querySelector('.js-wishlist-move-to-cart');
            if (atcBtn) atcBtn.dataset.variantId = newVariantId;
            if (newPrice) {
              const priceSpan = card.querySelector('.js-card-price');
              if (priceSpan) priceSpan.textContent = newPrice;
            }
          }
        });
      });

      // Bind Single Item Move to Cart
      grid.querySelectorAll('.js-wishlist-move-to-cart').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const id = btn.dataset.id;
          const variantId = btn.dataset.variantId;
          const card = btn.closest('.wishlist-card');
          const currentVariantId = card ? card.dataset.variantId || variantId : variantId;

          if (!currentVariantId) {
            window.location.href = items.find(i => String(i.id) === String(id))?.url || '/collections/all';
            return;
          }

          btn.disabled = true;
          const origText = btn.textContent;
          btn.textContent = 'Adding...';

          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
              ? cartDrawer.getSectionsToRender().map(s => s.id)
              : ['cart-drawer', 'cart-icon-bubble'];

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{ id: parseInt(currentVariantId, 10), quantity: 1 }],
                sections: sectionsToRender
              })
            });

            const data = await res.json();
            btn.disabled = false;
            btn.textContent = origText;

            if (res.ok) {
              window.Wishlist.remove(id);
              if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
                cartDrawer.renderContents(data);
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
              } else if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                window.location.href = '/cart';
              }
            } else {
              window.location.href = items.find(i => String(i.id) === String(id))?.url || '/collections/all';
            }
          } catch (err) {
            btn.disabled = false;
            btn.textContent = origText;
            window.location.href = items.find(i => String(i.id) === String(id))?.url || '/collections/all';
          }
        });
      });

      // Bind Select All Checkbox
      if (selectAllCheckbox) {
        selectAllCheckbox.onclick = () => {
          const isChecked = selectAllCheckbox.checked;
          grid.querySelectorAll('.js-item-checkbox').forEach(cb => {
            cb.checked = isChecked;
          });
          updateBulkVisibility();
        };
      }

      // Checkbox changes update Select All and Bulk Actions visibility
      grid.querySelectorAll('.js-item-checkbox').forEach(cb => {
        cb.addEventListener('change', () => {
          updateBulkVisibility();
        });
      });

      // Bind Bulk Move to Cart
      const bulkMoveBtn = section.querySelector('.js-wishlist-bulk-move');
      if (bulkMoveBtn) {
        bulkMoveBtn.onclick = async (e) => {
          e.preventDefault();
          const checkedBoxes = Array.from(grid.querySelectorAll('.js-item-checkbox:checked'));

          if (checkedBoxes.length === 0) {
            alert('Please select at least one item to move to cart.');
            return;
          }

          const itemsToAdd = [];
          const idsToRemove = [];

          checkedBoxes.forEach(cb => {
            const card = cb.closest('.wishlist-card');
            const vId = card?.dataset.variantId || card?.querySelector('.js-wishlist-move-to-cart')?.dataset.variantId;
            const pId = cb.dataset.id;
            if (vId) {
              itemsToAdd.push({ id: parseInt(vId, 10), quantity: 1 });
            }
            if (pId) {
              idsToRemove.push(pId);
            }
          });

          if (itemsToAdd.length === 0) return;

          bulkMoveBtn.disabled = true;
          const origText = bulkMoveBtn.textContent;
          bulkMoveBtn.textContent = 'Adding...';

          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
              ? cartDrawer.getSectionsToRender().map(s => s.id)
              : ['cart-drawer', 'cart-icon-bubble'];

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: itemsToAdd,
                sections: sectionsToRender
              })
            });

            const data = await res.json();
            bulkMoveBtn.disabled = false;
            bulkMoveBtn.textContent = origText;

            if (res.ok) {
              window.Wishlist.removeMultiple(idsToRemove);
              if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
                cartDrawer.renderContents(data);
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
              } else if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                window.location.href = '/cart';
              }
            }
          } catch (err) {
            bulkMoveBtn.disabled = false;
            bulkMoveBtn.textContent = origText;
            console.error('Bulk move error:', err);
          }
        };
      }

      // Bind Bulk Delete
      const bulkDeleteBtn = section.querySelector('.js-wishlist-bulk-delete');
      if (bulkDeleteBtn) {
        bulkDeleteBtn.onclick = (e) => {
          e.preventDefault();
          const checkedBoxes = Array.from(grid.querySelectorAll('.js-item-checkbox:checked'));
          if (checkedBoxes.length === 0) {
            alert('Please select at least one item to delete.');
            return;
          }

          if (confirm(`Remove ${checkedBoxes.length} item(s) from your wishlist?`)) {
            const idsToRemove = checkedBoxes.map(cb => cb.dataset.id);
            window.Wishlist.removeMultiple(idsToRemove);
          }
        };
      }
    },

    ensurePageFallback() {
      if (window.location.pathname.endsWith('/pages/wishlist')) {
        const mainContent = document.getElementById('MainContent');
        const existingWishlist = document.querySelector('.wishlist-section');

        if (mainContent && (!existingWishlist || document.querySelector('.template-404'))) {
          document.title = 'My Wishlist – ' + (window.Shopify?.shop || 'ElectroDaves');
          mainContent.innerHTML = `
            <div class="wishlist-section page-width" data-move-btn-text="Move to cart" style="--wishlist-btn-bg: #D3122A; --wishlist-btn-color: #FFFFFF;">
              <div class="wishlist__header">
                <h1 class="wishlist__title">MY WISHLIST</h1>
                <p class="wishlist__login-subtext">
                  <a href="/account/login" class="wishlist__login-link">Login</a> to sync your wishlist across devices
                </p>
              </div>

              <div class="wishlist__toolbar js-wishlist-toolbar" style="display: none;">
                <div class="wishlist__toolbar-left">
                  <label class="wishlist__select-all-label">
                    <input type="checkbox" class="wishlist__checkbox js-wishlist-select-all" aria-label="Select all items">
                    <span>Select All</span>
                  </label>
                  <span class="wishlist__bulk-actions js-wishlist-bulk-actions" style="display: none;">
                    <span class="wishlist__toolbar-divider">|</span>
                    <button type="button" class="wishlist__action-link js-wishlist-bulk-move">
                      Move to cart
                    </button>
                    <span class="wishlist__toolbar-divider">|</span>
                    <button type="button" class="wishlist__action-link wishlist__action-link--delete js-wishlist-bulk-delete">
                      Delete
                    </button>
                  </span>
                </div>
              </div>

              <div class="wishlist__grid js-wishlist-grid"></div>

              <div class="wishlist__empty-state js-wishlist-empty" style="display: none;">
                <div class="wishlist__empty-icon">
                  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                </div>
                <h2 class="wishlist__empty-title">Your wishlist is empty</h2>
                <p class="wishlist__empty-subtitle">Explore our catalog and save your favorite items!</p>
                <a href="/collections/all" class="wishlist__empty-btn">EXPLORE PRODUCTS</a>
              </div>
            </div>
          `;
          this.renderPage();
        }
      }
    }
  };

  // Initializations on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    window.Wishlist.updateBadge();
    window.Wishlist.syncHeartIcons();
    window.Wishlist.ensurePageFallback();
    window.Wishlist.renderPage();

    // Intercept Wishlist Icon Clicks to open Drawer smoothly if not on /pages/wishlist
    document.querySelectorAll('a[href="/pages/wishlist"], .header__icon--wishlist').forEach(link => {
      link.addEventListener('click', (e) => {
        if (!window.location.pathname.endsWith('/pages/wishlist') && !link.classList.contains('wishlist-drawer__view-all-btn')) {
          e.preventDefault();
          window.Wishlist.openDrawer();
        }
      });
    });

    // Close drawer buttons
    document.querySelectorAll('.js-wishlist-drawer-close').forEach(btn => {
      btn.addEventListener('click', () => {
        window.Wishlist.closeDrawer();
      });
    });
  });
})();
